import React from 'react'
import PropTypes from 'prop-types'

import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import Skeleton from '@material-ui/lab/Skeleton'

const TableDetailRow = ({ value, title, firstColWidth, isLoading }) => {
  if (isLoading) {
    return (
      <TableRow hover>
        <TableCell width={firstColWidth}>{title}</TableCell>
        <TableCell>
          <Skeleton width="100%" height={21} variant="rect" />
        </TableCell>
      </TableRow>
    )
  }

  return (
    <TableRow hover>
      <TableCell width="30%">{title}</TableCell>
      <TableCell>{value}</TableCell>
    </TableRow>
  )
}

TableDetailRow.propTypes = {
  value: PropTypes.string,
  title: PropTypes.string,
  firstColWidth: PropTypes.string,
  isLoading: PropTypes.bool,
}

export default TableDetailRow
